// @owners { team: patients-team }
import { AltoSpinningLoader, Icon, PresentationListItem } from '@alto/design-system';
import React from 'react';

type Props = {
  show?: boolean;
  isLoading?: boolean;
};

export const AncillaryRow = ({ show, isLoading = false }: Props) => {
  if (isLoading) {
    return (
      <PresentationListItem
        LeftContent={
          <Icon
            name="syringe"
            type="grey"
          />
        }
        text={<AltoSpinningLoader testID="alto-spinning-loader" />}
      />
    );
  }

  if (show) {
    return (
      <>
        <PresentationListItem
          LeftContent={
            <Icon
              name="syringe"
              type="grey"
            />
          }
          text="Supplies included"
        />
      </>
    );
  }

  return null;
};
